const adjustPDFScale = (node) => {
  let { width } = node.getBoundingClientRect();
  let elements = document.querySelectorAll("div[id^='page'][id$='-div'], div[id^='pf'][data-page-no]");
  if (elements.length >= 1) {
    for (let i = 0; i < elements.length; i++) {
      let item = elements[i];
      let { width: itemWidth, height: itemHeight } = item.getBoundingClientRect();
      let ratio = width / itemWidth;
      let widthDiff = (itemWidth - width) / 2;
      let heightDiff = itemHeight * (1 - ratio) / 2;
      if (ratio && !isNaN(ratio) && ratio < 1) {
        item.style.transform = `scale(${ratio})`;
        item.style.marginLeft = `-${widthDiff}px`;
        const marginTopValue = i !== 0 ? heightDiff * 2 : heightDiff;
        item.style.marginTop = `-${marginTopValue}px`;
      }
    }
  }
};

export default adjustPDFScale;
